import * as actions from '../redux/actions';

import { KuposInput } from '../../../common';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const ContactInputTable = ({
  t,
  pbPaymentDetails,
  emailError,
  confirmEmailError,
  mobileError,
  onInputChange,
  onInputBlurContact,
}) => {
  const { contactDetails } = pbPaymentDetails;

  return (
    <div className="pb-payment-details-contact-input-table">
      <table className="passenger-input-personal-details">
        <tbody>
          <tr className="passenger-input-heading bold-text font10">
            <th className="emailinput">{t('PASSENGER_DETAILS.EMAIL_ID')}</th>
            <th className="email-input">{t('PASSENGER_DETAILS.EMAIL_CONFIRMATION')}</th>
            <th className="phone-input">{t('PASSENGER_DETAILS.PHONE_NUMBER')}</th>
          </tr>
          <tr className="passenger-input font10">
            <td className="email-input">
              <KuposInput
                className="kupos-border"
                type="email"
                value={contactDetails ? contactDetails.email : ''}
                onChange={text => onInputChange(text, 'email')}
                onBlur={text => onInputBlurContact(text, 'email')}
                error={emailError ? true : false}
                errorMessage={emailError ? t(emailError.message) : ''}
              />
            </td>
            <td className="email-input">
              <KuposInput
                className="kupos-border confirm-email"
                type="email"
                value={contactDetails ? contactDetails.confirmEmail : ''}
                onChange={text => onInputChange(text, 'confirmEmail')}
                onBlur={text => onInputBlurContact(text, 'confirmEmail')}
                error={confirmEmailError ? true : false}
                errorMessage={confirmEmailError ? t(confirmEmailError.message) : ''}
              />
            </td>
            <td className="phone-input">
              <KuposInput
                placeholder="9XXXXXXXX"
                className="kupos-border"
                type="tel"
                value={contactDetails ? contactDetails.mobile : ''}
                onChange={text => onInputChange(text, 'mobile')}
                onBlur={text => onInputBlurContact(text, 'mobile')}
                error={mobileError ? true : false}
                errorMessage={mobileError ? t(mobileError.message) : ''}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbPaymentDetails: state.pbPaymentDetails,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactInputTable);



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/ContactInputTable/ContactInputTable.js